import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from '../../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top";
import FieldsFactory from "../../../fields3/fields-factory";
import SelectFieldType from "./select-type/select-type";
import FieldManagementForm from "../../../fields3/render/management-form";


// Field vsegda dobavlyaetsya k Entity
// Tut nuzno znat' kakoi entity



class ModalAddField extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            entity                  : PropTypes.number,
            arrayOfExistingFieldIds : PropTypes.array,
            onSubmit                : PropTypes.func
        })
    };

    constructor(props) {
        super(props);

        // let curValue = props.params.newOnly ? 'new' : 'existing';
        // if (props.params.customField) curValue = 'edit';
        //

        this.state = {
            step: 'select-type',
            type: false
        };

        // this._bind('onClickNew', 'onClickBack', 'onSubmit');
    }

    onSelectType = (type) => {
        this.setState({
            step: 'field-details',
            type: type
        })
    }

    onClickSelectType = () => {
        this.setState({
            step: 'select-type',
            type: null
        });
    }

    render() {

        switch (this.state.step) {
            case 'select-type':
                return <SelectFieldType onSelectType={this.onSelectType} onCloseClick={this.closeModal} entity={this.entity}/>

            default:

                const field = FieldsFactory.get({
                    isCustom    : true, // important !
                    fieldId     : gd.utils.generateUIDWithCollisionChecking(this.props.params.arrayOfExistingFieldIds),
                    type        : this.state.type,
                    label       : ''
                })

                const topLeftContent = (
                    <div className="ui5-link-icon-default" onClick={this.onClickSelectType}>
                        <div className="icon i5-long-arrow-left"/>
                        Select type
                    </div>
                )

                return (
                    <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.stopPropagation}>
                        <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                        <FieldManagementForm field      = {field}
                                             isNewField = {true}
                                             entity     = {this.props.params.entity}
                                             onSubmit   = {this.props.params.onSubmit}/>
                    </div>
                )
        }
    }
}

module.exports = ModalAddField;
